var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Reset"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reset",
    clipPath: "url(#clip-Reset)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9897",
    "data-name": "Group 9897",
    transform: "translate(-807.85 -926.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19328",
    "data-name": "Path 19328",
    d: "M70.3,90.962c-.108.1-.216.2-.324.31L66.9,94.341a1.5,1.5,0,0,0-.117.144l-3.537-3.564c.3-.292.629-.625.984-.98l1.744,1.771a.182.182,0,0,1,.04-.022c0-.382,0-.759,0-1.141a6.336,6.336,0,0,0-1-3.352,6.322,6.322,0,0,0-6.583-2.791A6.328,6.328,0,0,0,53.59,92.27c.022.072.04.148.063.238-.458.144-.9.288-1.384.436a7.755,7.755,0,0,1,1.645-7.522,7.558,7.558,0,0,1,8.3-2.143c3.856,1.442,5.41,4.417,5.249,8.412.589-.589,1.177-1.182,1.775-1.78.377.364.714.692,1.056,1.016Z",
    transform: "translate(756.235 845.211)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19329",
    "data-name": "Path 19329",
    d: "M75.356,328.039a7.682,7.682,0,0,1-1.456-1.86c.413-.234.822-.463,1.209-.679.4.508.791,1.011,1.2,1.532C76.012,327.342,75.688,327.684,75.356,328.039Z",
    transform: "translate(735.256 613.426)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19330",
    "data-name": "Path 19330",
    d: "M136.384,379.2a7.718,7.718,0,0,1-2.184-.917c.252-.4.494-.8.728-1.182.6.252,1.177.5,1.788.755C136.613,378.273,136.5,378.731,136.384,379.2Z",
    transform: "translate(677.665 564.146)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19331",
    "data-name": "Path 19331",
    d: "M217.658,395.958c.4-.018.777-.036,1.177-.058.067.458.13.921.207,1.424-.481.027-.948.049-1.442.076C217.622,396.893,217.64,396.421,217.658,395.958Z",
    transform: "translate(598.013 546.191)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19332",
    "data-name": "Path 19332",
    d: "M273.881,380c.225.413.449.822.692,1.263l-1.078.494c-.166-.463-.328-.9-.494-1.353C273.288,380.27,273.575,380.139,273.881,380Z",
    transform: "translate(545.103 561.375)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19333",
    "data-name": "Path 19333",
    d: "M316.9,349.5c.234-.243.449-.463.674-.7.346.3.7.607,1.087.939-.283.283-.553.557-.836.849C317.484,350.193,317.183,349.834,316.9,349.5Z",
    transform: "translate(503.176 591.174)",
    fill: "#8d8d8d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.6da41a969a811b156a2e273b3a5267a1.svg";
export { ForwardRef as ReactComponent };